function formatBytes(bytes, isDecimal = false) {
  if (!Number.isFinite(bytes) || bytes < 0) return '';
  if (bytes === 0) return '0 B';

  const units = ['B', 'KB', 'MB', 'GB', 'TB'];
  const factor = isDecimal ? 1000 : 1024;

  const i = Math.floor(Math.log(bytes) / Math.log(factor));
  const val = bytes / Math.pow(factor, i);

  const decimals = i === 0 ? 0 : 1;

  return `${val.toFixed(decimals)} ${units[i] ?? 'B'}`;
}

export default formatBytes;
